import { AfterViewInit, Directive, OnDestroy } from '@angular/core';
import { AbstractAdyen3dsComponent } from '../abstract-adyen-3ds.component';
import { Adyen } from '../adyen.namespace';

@Directive()
export abstract class AbstractAdyenCardComponent<T extends Adyen.ICardComponentOptions = Adyen.ICardComponentOptions>
    extends AbstractAdyen3dsComponent<Adyen.ICardPaymentMethod, T>
    implements AfterViewInit, OnDestroy
{
    /**
     * Adyen checkout component id
     * @type  {Adyen.Component}
     */
    protected readonly componentId = Adyen.Component.Card;

    /**
     * Adyen checkout component instance
     * @type {Adyen.ICreditCardComponent | undefined}
     */
    protected component?: Adyen.ICreditCardComponent;

    ngAfterViewInit() {
        super.ngAfterViewInit();
        if (this.containerElement) {
            // when checkout is submitted we display validation if not valid
            this.subscriptions.add(
                this.checkoutStepComponent.submittedSubject.subscribe((submitted: boolean) => {
                    if (submitted && !this.isValid()) {
                        this.showValidation();
                    }
                })
            );
        }
    }

    ////////////////////////////////////////////
    ////////
    ////////    Cards component methods
    ////////
    ////////////////////////////////////////////

    /**
     * Reveals validation notifications for invalid fields
     */
    protected showValidation(): void {
        if (this.component) {
            this.component.showValidation();
        }
    }

    /**
     * Card component change callback
     * @param {Adyen.ICardComponentState} state
     * @param component
     */
    protected onCardComponentChange(state: Adyen.ICardComponentState, component) {}

    /**
     * returns ecrypted form fields values
     * @return {Adyen.ICardComponentPaymentData | undefined}
     */
    protected getComponentData(): Adyen.ICardComponentData | undefined {
        return this.component && this.component.state.data;
    }

    /**
     * returns true if all credit card component fields are valid
     * @returns {boolean}
     */
    protected isValid(): boolean {
        return !!(this.component && this.component.isValid);
    }

    /**
     * return credit card type if available
     * @returns {string | undefined}
     */
    protected getCardBrand(): string | undefined {
        if (this.component && this.component.state && this.component.state.brand) {
            return this.component.state.brand.toUpperCase();
        }
        return undefined;
    }
}